// extracted by mini-css-extract-plugin
module.exports = {"flashback":"index_flashback__a1BBf","icon":"index_icon__sTHj6","hidden":"index_hidden__4rV2i","inChat":"index_inChat__CLY4a"};